import { FC, CSSProperties } from 'react';

type Props = {
  size: number;
  radius: number;
  rootStyle?: CSSProperties;
  circleStyle?: CSSProperties;
}

const Circle:FC<Props> = ({
  // Props
  size, radius, rootStyle = {}, circleStyle = {}
}) => {
  const centerPoint = size/2;
  return (
    <svg
      className="
        absolute top-1/2 left-1/2
        transform -translate-x-1/2 -translate-y-1/2
      "
      style={{
        ...rootStyle,
        width: size,
        height: size
      }}
    >
      <circle
        className="stroke-progress"
        style={{
          strokeLinecap: 'round',
          fill: 'none',
          ...circleStyle
        }}
        transform={`rotate(-90, ${centerPoint}, ${centerPoint})`}
        r={radius} cx={centerPoint} cy={centerPoint}
      ></circle>
    </svg>
  )
}

export default Circle;
